<app-statistik-tilafgang-options class="d-flex"
                              (selectLedelseAnsvarlig)="onLedelseAnsvarligSelected($event)"
                              (selectKundeAnsvarlig)="onKundeAnsvarligSelected($event)"
                              (selectSagsAnsvarlig)="onSagsAnsvarligeSelected($event)"
                              (periodeChange)="onPeriodeChange($event)"
                              [laID]="laID"
                              [kaID]="kaID"
                              [saID]="saID"
                              [periode]="periode"
                              [laCards]="laCards"
                              [kaCards]="kaCards"
                              [saCards]="saCards"
                              ></app-statistik-tilafgang-options>

<section class="table__viewport">
    <table class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
            <tr>
                <th colspan="7"><h3> Nye Kunder: </h3></th>
            </tr>
            <tr>
                <th> Nr</th>
                <th> Navn</th>
                <th> </th>
                <th> LA / KA</th>
                <th class="text-end"> Kundestart </th>
                <th class="text-end"> Regnskabsafslutning </th>
                <th class="text-end"> Forventet oms</th>
            </tr>
        </thead>

        <tbody>
            <ng-container *ngFor="let nyKunde of filterByLaKaSa(nyeKunder);">
                <tr class="item__tr">
                    <td>{{nyKunde.glkundenr}}</td>
                    <td>{{nyKunde.navn1}}</td>
                    <td>{{nyKunde.navn2}}</td>
                    <td>{{findLaName(nyKunde.ledelsesansvarlig)}} / {{findKaName(nyKunde.kundeansvarlig)}}</td>
                    <td class="text-end">{{nyKunde.kundestart | date:'mediumDate':'':'da'}}</td>
                    <td class="text-end">{{nyKunde.regnskabsafslutning | date:'mediumDate':'':'da'}}</td>
                    <td class="text-end">{{nyKunde.forventoms | currency:'DKK':'':'1.0-0':'da'}}</td>
                </tr>
            </ng-container>
            <tr>
                <th colspan="5">Total</th>
                <th class="text-end">{{nyeKunder.length}}</th>
                <th class="text-end">{{totalNyForventetOms | currency:'DKK':'':'1.0-0':'da' }}</th>
            </tr>
        </tbody>
    </table>

    <table class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
            <tr>
                <th colspan="11"><h3> Mistede Kunder: </h3></th>
            </tr>
            <tr>
                <th> Nr</th>
                <th class="text-nowrap">Navn</th>
                <th></th>
                <th class="text-nowrap">La/Ka</th>
                <th class="text-end text-nowrap">Kundestart</th>
                <th class="text-end text-nowrap">Ophort dato</th>
                <th style="max-width: 150px;">Ophort grund</th>
                <th class="text-end text-nowrap">Regnskabsafslutning</th>
                <th class="text-end text-nowrap">BR ERS</th>
                <th class="text-end text-nowrap">Kode</th>
                <th class="text-end text-nowrap">Oms</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let mistetKunde of filterByLaKaSa(mistedeKunder)">
                <tr class="item__tr">
                    <td>{{mistetKunde.glkundenr}}</td>
                    <td class="text-nowrap">{{mistetKunde.navn1}}</td>
                    <td class="text-nowrap">{{mistetKunde.navn2}}</td>
                    <td class="text-nowrap">{{findLaName(mistetKunde.ledelsesansvarlig)}} / {{findKaName(mistetKunde.kundeansvarlig)}}</td>
                    <td class="text-end text-nowrap">{{getDateString(mistetKunde.kundestart) | date:'mediumDate':'':'da'}}</td>
                    <td class="text-end text-nowrap">{{getDateString(mistetKunde.kundeophortDato) | date:'mediumDate':'':'da'}}</td>
                    <td style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" [title]="mistetKunde.kundeophortGrund">
                        {{mistetKunde.kundeophortGrund}}
                    </td>
                    <td class="text-end text-nowrap">{{mistetKunde.regnskabsafslutning | date:'mediumDate':'':'da'}}</td>
                    <td class="text-end text-nowrap">{{getErhvervselskabmedel(mistetKunde.erhvervselskabmedel)}}</td>
                    <td class="text-end" [ngStyle]="{'background-color': getColorCode(mistetKunde.kundeophortKode)}"></td>
                    <td class="text-end text-nowrap">{{mistetKunde.oms | currency:'DKK':'':'1.0-0':'da'}}</td>
                </tr>
            </ng-container>
            <tr>
                <th colspan="9">Total</th>
                <th class="text-end">{{mistedeKunder.length}}</th>
                <th class="text-end">{{totalMistetOms | currency:'DKK':'':'1.0-0':'da' }}</th>
            </tr>
        </tbody>
    </table>

    <table class="table table-hover table-striped table-sm table-frame__body w-auto">
        <thead class="fixed-top position-fixed position-sticky">
            <tr>
                <th colspan="3"><h3>Totalt</h3></th>
            </tr>
            <tr>
                <th> Grund</th>
                <th> Kode</th>
                <th class="text-end"> Antal</th>
            </tr>

            <ng-container>
                <tr class="item__tr">
                    <td> Pris</td>
                    <td class="text-end" [ngStyle]="{'background-color': 'blue'}"></td>
                    <td class="text-end">{{(mistedeKunder | StatistikTilafgangGrundPipe)[0]}}</td>
                </tr>

                <tr class="item__tr">
                    <td> Kemi</td>
                    <td class="text-end" [ngStyle]="{'background-color': 'green'}"></td>
                    <td class="text-end">{{(mistedeKunder | StatistikTilafgangGrundPipe)[1]}}</td>
                </tr>

                <tr class="item__tr">
                    <td> Konkurs</td>
                    <td class="text-end" [ngStyle]="{'background-color': 'red'}"></td>
                    <td class="text-end">{{(mistedeKunder | StatistikTilafgangGrundPipe)[2]}}</td>
                </tr>

                <tr class="item__tr">
                    <td> Salg/Død</td>
                    <td class="text-end" [ngStyle]="{'background-color': 'black'}"></td>
                    <td class="text-end">{{(mistedeKunder | StatistikTilafgangGrundPipe)[3]}}</td>
                </tr>

                <tr class="item__tr">
                    <td> Andet</td>
                    <td class="text-end" [ngStyle]="{'background-color': 'grey'}"></td>
                    <td class="text-end">{{(mistedeKunder | StatistikTilafgangGrundPipe)[4]}}</td>
                </tr>
            </ng-container>
        </thead>
    </table>
</section>
